import { useCallback } from "react";
import { useMatches } from "react-router";

export function useCurrentRoute() {
	const matches = useMatches();
	const currentRoute = matches[matches.length - 1];
	const routeId = currentRoute?.id ?? "";

	const isProductsRoute = useCallback(
		() => routeId.includes("products") && !routeId.includes("productId"),
		[routeId],
	);

	return {
		currentRoute,
		isProductsRoute,
	};
}
